import { render, staticRenderFns } from "./seo-block.vue?vue&type=template&id=3c04452a&scoped=true&"
import script from "./seo-block.vue?vue&type=script&lang=js&"
export * from "./seo-block.vue?vue&type=script&lang=js&"
import style0 from "./seo-block.vue?vue&type=style&index=0&id=3c04452a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04452a",
  null
  
)

export default component.exports